import routerOptions0 from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.4_@parcel+watcher@2.5.6_@types+node@25.6.2_@vue+compiler-sfc@3.5.34_cac@6.7.1_7a721da671d222832e42303c3bb323ce/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}